module.exports = __webpack_public_path__ + "static/media/couch.b14eea7b.svg";